import ENV from "../env";

const Config = {
    domain: ENV.domain || 'www.yettel.rs',
    prefixUrl: ENV.prefixUrl || '',
    tnAccountClientId: ENV.tnAccountClientId || 'webshop-mperic',
    tnAccountDomain: ENV.tnAccountDomain || 'https://www.yettel.rs/nalog',
    tnAccountClientSecret: ENV.tnAccountClientId || '123456'
}

export default Config;
